<template>
  <div class="token-benefits bg--color-01">
    <div class="container-wrapper bg--color-10">
      <div class="token-benefits__container container-new">
        <span
          class="token-benefits__title txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold"
        >
          {{ $t('tokenNew.benefitsBlock.title') }}
        </span>

        <div class="token-benefits__image">
          <!-- <img :src="require('@/assets/img/token/long-arrow.svg')" class="token-benefits__long-arrow"> -->
          <img
            :src="require('@/assets/img/token/benefits.png')"
            loading="lazy"
            class="main-image"
            alt="coins image"
          >
          <img
            :src="require('@/assets/img/token/gifs/benefits-stars.gif')"
            loading="lazy"
            class="stars"
            alt="stars gif"
          >
          <!-- <img :src="require('@/assets/img/token/gifs/benefits.gif')"> -->
          <!-- <video
            loop
            autoplay
            muted
            playsinline
          >
            <source :src="require('@/assets/img/token/gifs/benefits.mp4')" type="video/mp4">
            Your browser does not support the video tag.
          </video> -->
        </div>

        <div class="token-benefits__items flx flx--col">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="token-benefits__item"
          >
            <div
              class="token-benefits__item-number txt txt--18px txt--weight-600 txt--color-04"
            >
              {{ index + 1 }}
            </div>

            <div class="token-benefits__item-content flx flx--col">
              <span
                class="txt txt--22px txt--height-30px txt--color-04 txt--bold"
              >
                {{ item.title }}
              </span>
              <span class="txt txt--16px txt--height-20px txt--color-04">
                {{ item.text }}
              </span>

              <exc-button
                v-if="item.btn"
                size="xs"
                outline
                :soon="item.btn.isSoon"
                :to="!item.btn.isSoon ? item.btn.link : ''"
                class="token-benefits__item-btn mt-16"
              >
                {{ item.btn.text }}
              </exc-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '@/components/common'

export default {
  components: { ExcButton },
  computed: {
    items () {
      return [
        {
          btn: {
            text: this.$t('tokenNew.benefitsBlock.freezeBtn'),
            isSoon: false,
            link: this.localePath('/user/ticket'),
          },
        },
        {
          btn: {
            text: this.$t('tokenNew.benefitsBlock.getNowBtn'),
            isSoon: false,
            link: this.localePath('/user/ticket'),
          },
        },
        {
          btn: {
            text: this.$t('tokenNew.benefitsBlock.upgradeBtn'),
            isSoon: false,
            link: this.localePath('/user/ticket'),
          },
        },
      ].map((item, index) => {
        item.title = this.$t(`tokenNew.benefitsBlock.items.${index}.title`)
        item.text = this.$t(`tokenNew.benefitsBlock.items.${index}.text`)
        return item
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.token-benefits {
  &__container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      'title'
      'items'
      'image';
    align-items: center;
    gap: toRem(22px);

    @include bp(m) {
      grid-template-areas:
        'title items'
        'image items';
      grid-template-columns: 1fr 1fr;
      gap: toRem(24px);
    }
  }

  &__image {
    grid-area: image;
    position: relative;
    display: flex;

    .main-image {
      max-width: 100%;
      max-height: 235px;

      @include bp(m) {
        max-height: unset;
        max-width: 80%;
      }
    }

    .stars {
      position: absolute;
      left: 0;
      top: 0;
      max-height: 100%;
    }
  }

  &__long-arrow {
    max-height: toRem(100px);

    @include bp(m) {
      display: none;
    }
  }

  &__title {
    grid-area: title;
  }

  &__items {
    grid-area: items;
    gap: toRem(22px);
  }

  &__item {
    padding: toRem(12px);
    border-radius: toRem(20px);
    background: rgba(255, 255, 255, 0.1);

    display: grid;
    grid-template-columns: toRem(28px) 1fr;
    gap: toRem(10px);

    &-content {
      gap: toRem(8px);
    }

    &-number {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 100%;
      width: toRem(28px);
      height: toRem(28px);
      line-height: toRem(28px);
      text-align: center;
    }

    &-btn {
      max-width: fit-content;
    }
  }
}
</style>
